import { configureStore } from '@reduxjs/toolkit';
import adminReducer from './slices/admin-slice';
import authReducer from './slices/auth-slice';
import contentReducer from './slices/content-slice';
import daysReducer from './slices/days-slice';
import gamesReducer from './slices/games-slice';
import pendingReducer from './slices/pending-slice';
import profileReducer from './slices/profile-slice';
import uiReducer from './slices/ui-slice';

/**
 * Public-website Redux store.
 *
 * Six slices per design §3.1: auth, profile, content, days, games, ui.
 * Concrete reducers land in their respective feature tasks; this file
 * wires the empty stubs from day one so the SPA's `<Provider store>`
 * boundary is stable.
 */
export const store = configureStore({
  reducer: {
    admin: adminReducer,
    auth: authReducer,
    profile: profileReducer,
    content: contentReducer,
    days: daysReducer,
    games: gamesReducer,
    pending: pendingReducer,
    ui: uiReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
